module.exports = __webpack_public_path__ + "img/2276.08dfc904.gif";